export const environment = {
  production: true,
  configLocation: './assets/config/config.json',
  zkparentNode: undefined,
  aclDigests: []
};
